import helper from '../helper';

function shackeField($field) {
    $field.addClass('shake');
    $field.one(helper.whichAnimationEvent(), function () {
        $field.removeClass('shake');
    });
}

export default function ($form) {
    if ($form.find('.validataion--either-or').length > 0) {
        let eO = 0;
        $form.find('.validataion--either-or').each(function (index, el) {
            if ($(this).val().replace(/\s/g, '').length > 0) {
                eO += 1;
            }
        });
        if (eO === 0) {
            helper.showFieldError(
                $form.find('input[type=tel]'),
                'Заполните поле'
            );
            return false;
        }
    } else if ($form.find('[required]').length > 0) {
        let errors = 0;
        $form.find('[required]:visible').each(function (index, el) {
            if ($(this).val().replace(/\s/g, '').length == 0) {
                helper.showFieldError($(this), 'Заполните поле');
                errors++;
            }
        });
        $form.find('[required][type=checkbox]').each(function (index, el) {
            if ($(this).parent().is(':visible') && !$(this).prop('checked')) {
                shackeField($(this).parent());
                errors++;
            }
        });
        if (errors > 0) {
            return false;
        }
    }
    return true;
}
